import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import ConfirmationModalNew from "../../common/ConfirmationModalNew";

const ChartUpdatesDialog = ({ 
  open, 
  onClose, 
  onConfirm, 
  title = "",
  titleClassName = ""
}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleProceedToChart = () => {
    onClose();
    id && navigate(`/patient/${id}/`);
  };

  return (
    <ConfirmationModalNew
      open={open}
      handleClose={handleProceedToChart}
      onCross={onClose}
      title={title}
      titleClassName={titleClassName}
      headClassName="px-8 pt-8 pb-4"
      className="!min-w-[630px]"
      actionsClassName="justify-items-center"
      buttonClassName="!w-[270px]"
      content={() => (
        <div className="flex flex-col px-2">
          <div className="text-gray-800 text-[20px] font-semibold mb-4">
            Maintain Consistency with Clinical Guidelines
          </div>
          <div className="text-gray-800 text-base font-normal mb-4">
            To ensure the integrity of clinical outcomes, changes to the Patient Chart will be restricted until the Minor Ailment Assessment has been completed or cancelled.
          </div>
          <div className="text-gray-800 text-base font-normal">
            This includes no access to medical history, medications, and vaccines.
          </div>
        </div>
      )}
      confirmText="Back to Assessment"
      confirmAction={onConfirm}
      cancelText="Proceed to Patient Chart"
      cancelBtnType="primary-outline"
      verticalButtons={false}
    />
  );
};

export default ChartUpdatesDialog;
